import React from 'react';

import {useGate, useUnit} from 'effector-react';
import {useTranslation} from 'react-i18next';

import {MetricCard, MetricCardGrid} from '@/widgets/MetricCard';
import {Period} from '@/widgets/Period';
import {SummaryGate, summaryModel} from '@entities/summary/model';
import {BlockWrapper, Header, SummaryWrapper, Wrapper} from '@pages/Dashboard/styled';
import {Title} from '@shared/ui/Title';
import {handleNil} from '@utils/handleNil';
import {formatNumberWithFraction} from '@utils/number';

const metricGridStyles = {
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    padding: 0,
    boxShadow: 'none',
    background: 'transparent',
};

export const DashboardPage = () => {
    const {t} = useTranslation();
    const {state} = useUnit(summaryModel);
    useGate(SummaryGate);

    return (
        <Wrapper>
            <Header style={{gridColumn: '1 / -1'}}>
                <Title size={2}>{t('page_main.title')}</Title>
                <Period requireMonth={false} />
            </Header>
            <SummaryWrapper>
                <BlockWrapper>
                    <Title size={4}>{t('page_main.invoices.income')}</Title>
                    <MetricCardGrid style={metricGridStyles}>
                        <MetricCard
                            label={t('page_main.counterparties_count')}
                            value={handleNil(state.counts?.buyersCount)}
                        />
                        <MetricCard
                            label={t('page_main.sum')}
                            value={formatNumberWithFraction(state.data?.incomingTotalAmountWithVat)}
                        />
                        <MetricCard
                            label={t('page_main.invoice_count')}
                            value={handleNil(state.data?.incomingCount)}
                        />
                        <MetricCard
                            label={t('page_main.tax_sum')}
                            value={formatNumberWithFraction(state.data?.incomingTotalVat)}
                        />
                    </MetricCardGrid>
                </BlockWrapper>
                <BlockWrapper>
                    <Title size={4}>{t('page_main.invoices.outcome')}</Title>
                    <MetricCardGrid style={metricGridStyles}>
                        <MetricCard
                            label={t('page_main.counterparties_count')}
                            value={handleNil(state.counts?.sellersCount)}
                        />
                        <MetricCard
                            label={t('page_main.sum')}
                            value={formatNumberWithFraction(state.data?.outgoingTotalAmountWithVat)}
                        />
                        <MetricCard
                            label={t('page_main.invoice_count')}
                            value={handleNil(state.data?.outgoingCount)}
                        />
                        <MetricCard
                            label={t('page_main.tax_sum')}
                            value={formatNumberWithFraction(state.data?.outgoingTotalVat)}
                        />
                    </MetricCardGrid>
                </BlockWrapper>
                <BlockWrapper>
                    <Title size={4}>{t('page_main.period')}</Title>
                    <MetricCardGrid
                        style={{
                            ...metricGridStyles,
                            // gridTemplateColumns: 'repeat(2, 1fr)'
                        }}
                    >
                        <MetricCard
                            label={t('page_main.balance')}
                            value={formatNumberWithFraction(state.data?.vatBalance)}
                        />
                        {/*<MetricCard label={t('page_main.dec_status')} value={handleNil(null)} />*/}
                    </MetricCardGrid>
                </BlockWrapper>
            </SummaryWrapper>
        </Wrapper>
    );
};
